/* eslint-disable no-undefined, max-len */
/* eslint-disable max-len */
import {getImageUrl} from './get-image-url';

export const banksH1Text = (city, date) => (
  `Курс валют в ${city} на ${date}`
);

export const banksTitleText = (city, date) => (
  `Курс валют в ${city} на ${date} в банках от NUR.KZ`
);

export const nbrkH1Text = date => (
  `Курсы Валют: Нацбанк РК на ${date}`
);

export const altScreenData = {
  AUCTION_SUCCESS: {
    imgUrl: getImageUrl('auction-submit.svg'),
    imgAlt: 'Ваша заявка подана!',
    heading: 'Ваша заявка подана!',
    text: 'Через 15 минут с вами свяжется сотрудник победившего пункта обмена для обсуждения деталей сделки.\n\n Новую заявку на обмен вы сможете подать через '
  },
  AUCTION_SUSPENSE: {
    imgUrl: getImageUrl('auction-closed.svg'),
    imgAlt: 'Заявка не подана',
    heading: 'Заявка не подана',
    text: 'Похоже, что Вы недавно подали заявку на обмен валюты.\n\n Новую заявку на обмен Вы сможете подать через '
  },
  AUCTION_CLOSED: {
    imgUrl: getImageUrl('auction-closed.svg'),
    imgAlt: 'Аукцион временно недоступен.',
    heading: 'Обмен валют открыт с 9:00 до 18:00',
    text: 'Так как в обмене валют учавствуют обменные пункты города Алматы, заявку на обмен валюты можно подать только в рабочие часы.'
  }
};
